import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/contextHelpers';

import { NamedLink } from '../../components';

import css from './SectionLocations.module.css';

import audioEquipmentImage from './images/audioEquipment.jpg';
import performersImage from './images/performers.jpg';
import concertHallsImage from './images/concertHalls.jpg';


class LocationImage extends Component {
  render() {
    const { alt, ...rest } = this.props;
    return <img alt={alt} {...rest} />;
  }
}
const LazyImage = lazyLoadWithDimensions(LocationImage);

const locationLink = (name, image, searchQuery) => {
  const nameText = <span className={css.locationName}>{name}</span>;
  return (
    <NamedLink name="SearchPage" to={{ search: searchQuery }} className={css.location}>
      <div className={css.imageWrapper}>
        <div className={css.aspectWrapper}>
          <LazyImage src={image} alt={name} className={css.locationImage} />
        </div>
      </div>
      <div className={css.linkText}>
        <FormattedMessage
          id="SectionLocations.listingsInLocation"
          values={{ location: nameText }}
        />
      </div>
    </NamedLink>
  );
};

const SectionLocations = props => {
  const { rootClassName, className, intl } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionLocations.title" />
      </div>
      <div className={css.locations}>
        {locationLink(
          intl.formatMessage({id: 'SectionLocations.audioEquipment'}),
          audioEquipmentImage,
          'pub_subcategory=auv_audio'
        )}
        {locationLink(
          intl.formatMessage({id: 'SectionLocations.performers'}),
          performersImage,
          'pub_subcategory=pserv_muziki'
        )}
        {locationLink(
          intl.formatMessage({id: 'SectionLocations.concertHalls'}),
          concertHallsImage,
          'pub_subcategory=tuv_zales'
        )}
      </div>

      <div className={css.locationButtonHolder}>
        <NamedLink
          name="CategoriesPage"
          className={css.locationButton}
        >
          <FormattedMessage id="SectionLocations.allCategories" />
        </NamedLink>
      </div>


    </div>
  );
};

SectionLocations.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionLocations.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionLocations;
